import {
  COMPANY_GET_LIST,
  COMPANY_CONTACT_SALES,
  COMPANY_ADD_USER,
  COMPANY_REMOVE_USER,
  COMPANY_UPDATE_USER,
  COMPANY_REQUEST,
  COMPANY_SUCCESS,
  COMPANY_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  companies: null,
  isLoading: false,
  error: null
}

const getters = {
  getCompanies: (state) => state.companies,
  isCompanyLoading: (state) => state.isLoading,
  getCompanyError: (state) => state.error
}

const actions = {
  [COMPANY_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(COMPANY_REQUEST)

      axios
        .get("/api/v3/companies/?page_size=100")
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(COMPANY_SUCCESS, { companies: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(COMPANY_ERROR, err)
          reject(err)
        })
    })
  },
  [COMPANY_CONTACT_SALES]: ({ commit }, { name, numAgents, message }) => {
    return new Promise((resolve, reject) => {
      commit(COMPANY_REQUEST)

      axios
        .post("/api/v3/companies/contact/", {
          team_name: name,
          num_agents: numAgents,
          message
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(COMPANY_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(COMPANY_ERROR, err)
          reject(err)
        })
    })
  },
  [COMPANY_ADD_USER]: ({ commit }, { id, userData }) => {
    return new Promise((resolve, reject) => {
      commit(COMPANY_REQUEST)

      const formatted = {
        username: userData.email,
        name: userData.name,
        phone: userData.phone,
        is_agent: userData.isAgent,
        can_create: userData.canCreate,
        show_my_payments: userData.showMyPayments,
        show_accept_reject_button: userData.showAcceptRejectButton,
        copy_settings: userData.copySettings,
        create_default_apptemplate: userData.createDefaultApptemplate,
        default_apptemplate_slug: userData.slug,
        selected_rsp: userData.selectedRsp
      }

      axios
        .post(`/api/v3/companies/${id}/add_user/`, formatted)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(COMPANY_SUCCESS, { membership: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(COMPANY_ERROR, err)
          reject(err)
        })
    })
  },
  [COMPANY_UPDATE_USER]: ({ commit }, { id, userData }) => {
    return new Promise((resolve, reject) => {
      commit(COMPANY_REQUEST)

      const formatted = {
        username: userData.email,
        is_agent: userData.isAgent,
        can_create: userData.canCreate,
        show_my_payments: userData.showMyPayments,
        show_accept_reject_button: userData.showAcceptRejectButton
      }

      axios
        .patch(`/api/v3/companies/${id}/update_user/`, formatted)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(COMPANY_SUCCESS, { membership: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(COMPANY_ERROR, err)
          reject(err)
        })
    })
  },
  [COMPANY_REMOVE_USER]: ({ commit }, { id, userId }) => {
    return new Promise((resolve, reject) => {
      commit(COMPANY_REQUEST)

      axios
        .post(`/api/v3/companies/${id}/remove_user/`, {
          user: userId
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(COMPANY_SUCCESS, { remove: userId })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(COMPANY_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [COMPANY_REQUEST]: (state) => {
    state.isLoading = true
  },
  [COMPANY_SUCCESS]: (state, { companies, membership, remove } = {}) => {
    state.isLoading = false

    if (companies) {
      state.companies = companies.results
    }

    // add or update
    if (membership) {
      state.companies = state.companies.map((c) => {
        if (c.id === membership.company_id) {
          c.memberships = [membership, ...c.memberships.filter((m) => m.id !== membership.id)]
        }
        return c
      })
    }

    if (remove) {
      state.companies = state.companies.map((c) => {
        c.memberships = c.memberships.filter((m) => m.user.id !== remove)
        return c
      })
    }
  },
  [COMPANY_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
